import React, { useEffect } from 'react';
import { HTTPService } from 'core/services';
import { getSowDataPath } from 'core/routing/paths';
import { useAppDispatch, useAppSelector } from 'core/store';
import { useParams, useSearchParams } from 'react-router-dom';
import getSalesSowAction from 'core/actions/Sales/GetSalesSow/actions';
import { REQUEST_BUNDLES_TYPE } from 'core/actions/Sales/RequestBundles/constants';
import ContractFormCreate from 'pages/WirelineEngagements/shared/ContractForm/ContractFormCreate';

const ordersInfoController = HTTPService.getController();

const SowDataContractRequestCreate = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const { wirelineEngagementId, customerId } = useParams();

  const orders = useAppSelector((state) => state.wirelineEngagements.salesSow.results);
  const isOrdersLoading = useAppSelector((state) => state.wirelineEngagements.salesSow.isLoading);

  const orderIds = searchParams.get('orderIds')?.split(',') || [];
  const backRoutePath = getSowDataPath(wirelineEngagementId, customerId);

  const orderIdsParams = {
    page: 1,
    search: '',
    ordering: '',
    page_size: orderIds.length,
    orderId: orderIds.toString(),
  };

  useEffect(() => {
    dispatch(getSalesSowAction(ordersInfoController, orderIdsParams));
  }, []);

  return (
    <ContractFormCreate
      orderIds={orderIds}
      selectedOrders={orders}
      backRoutePath={backRoutePath}
      isLoadingOrders={isOrdersLoading}
      requestType={REQUEST_BUNDLES_TYPE.CONTRACT}
    />
  );
};

export default SowDataContractRequestCreate;
